export default {
    // 比较时间大小
    compareDate () {
        let date = new Date(),
            year = date.getFullYear(), //获取完整的年份(4位)
            month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
            strDate = date.getDate(); // 获取当前日(1-31)
        const HH =
            new Date().getHours() < 10
                ? "0" + new Date().getHours()
                : new Date().getHours();
        const mm =
            new Date().getMinutes() < 10
                ? "0" + new Date().getMinutes()
                : new Date().getMinutes();
        const ss =
            new Date().getSeconds() < 10
                ? "0" + new Date().getSeconds()
                : new Date().getSeconds();

        if (month >= 1 && month <= 9) month = "0" + month; // 如果月份是个位数，在前面补0
        if (strDate >= 0 && strDate <= 9) strDate = "0" + strDate; // 如果日是个位数，在前面补0

        let date1 = year + '-' + month + '-' + strDate + ' ' + HH + ':' + mm + ':' + ss;

        return date1; 

    },


    contrastDate ( date1,date2) {
        var oDate1 = new Date(date1);
        var oDate2 = new Date(date2);
        if (oDate1.getTime() > oDate2.getTime()) {
            return true; //第1个大
        } else {
            return false; //第2个大
        }
    },
};
